import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import css from './PurchaseCloseModalAlert.module.scss';

interface Props {
  className?: string;
  labelType: string;
}

const PurchaseCloseModalAlert = ({
  className,
  labelType,
  intl,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.PurchaseCloseModalAlert, className);

  return (
    <div className={classes}>
      <span className={css.PurchaseCloseModalAlert__Text}>
        {intl.formatMessage({
          id: `purchases.purchaseCloseModalAlert.message.${labelType}`,
        })}
      </span>
    </div>
  );
};

export default injectIntl(PurchaseCloseModalAlert);
